import { createContext, useContext } from "react";

export type FieldInfoLabelsContextValue = {
	getFieldLabel: (key: string) => string;
	isLoading: boolean;
};

const defaultGetFieldLabel = () => "";

/** Used when skipping `useFieldInfoLabels` (e.g. TanStack Start prerender — avoids React Query GC timers hanging the build). */
export const defaultFieldInfoLabelsValue: FieldInfoLabelsContextValue = {
	getFieldLabel: defaultGetFieldLabel,
	isLoading: false,
};

/**
 * Shared context for field-info labels. `FieldInfoLabelsProvider` (separate module)
 * supplies the value; consumers use `useAppTranslation()` or `useFieldInfoLabelsContext()`.
 */
export const FieldInfoLabelsContext =
	createContext<FieldInfoLabelsContextValue | null>(null);

export function useFieldInfoLabelsContext(): FieldInfoLabelsContextValue {
	return useContext(FieldInfoLabelsContext) ?? defaultFieldInfoLabelsValue;
}
